module.exports = __webpack_public_path__ + "img/warning.1c3485c9.svg";